module.exports = __webpack_public_path__ + "fonts/VWHeadWeb-Bold.6d374dc.woff2";